import axios from 'axios'
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {ApiLanguages, ApiUrls} from "../config/urls";
import {useAuth} from "../context/auth-context";
import {toast} from "react-toastify";

export function useCart(language) {
    const auth = useAuth();
    const userEmail = auth?.user?.email;

    let queryKey = [ApiUrls.SHOP_CART_GET.replace('{lng}', language), userEmail];
    if (!auth.isAuthenticated && auth?.cart?.id) {
        queryKey = [ApiUrls.GUEST_CART_GET.replace('{lng}', language).replace('{id}', auth.cart.id)];
    }

    return useQuery({
        enabled: auth.isAuthenticated ||  Boolean(auth?.cart?.id),
        queryKey: queryKey,
        onSuccess: (data) => {
            console.log('update Cart', data);
            auth.setCart(data.cart);
        }
    })
}

function updateCart(language, url, message = null) {
    const queryClient = useQueryClient();
    const auth = useAuth();

    let shopCartQueryKey = [ApiUrls.SHOP_CART_GET.replace('{lng}', language)];

    if (!auth.isAuthenticated && auth.cart?.id) {
        shopCartQueryKey = [ApiUrls.GUEST_CART_GET.replace('{lng}', language).replace('{id}', auth.cart.id)];
    }

    return useMutation({
        networkMode: 'always',
        mutationFn:(product) => axios.post(url.replace('{id}', product.id))
            .then((res) => {
                if (res.data.success === true) {
                    console.log(res.data.data.cart);
                    auth.setCart(res.data.data.cart);
                    queryClient.setQueryData(shopCartQueryKey, (prev) => {
                        return  res.data.data;
                    });
                    ApiLanguages.forEach((apiLanguage) => {
                        const queryKey = [(!auth.isAuthenticated ? ApiUrls.GUEST_CART_GET : ApiUrls.SHOP_CART_GET).replace('{lng}', apiLanguage).replace('{id}', res.data.data.cart.id)];
                        queryClient.invalidateQueries({queryKey: queryKey});
                    });
                    // auth.clearReactQueryCache();

                    if (message) {
                        if (url.includes('add-to-cart')) {
                            toast.success(product.name + message);
                        } else {
                            toast.warning(product.name + message);
                        }
                    }
                } else {
                    console.log(res);
                    return res.data;
                }
            })
    });
}

export function useRemoveFromCart(language, message) {
    const auth = useAuth();
    let url =  ApiUrls.SHOP_REMOVE_FROM_CART.replace('{lng}', language);
    if (!auth.isAuthenticated && auth.cart?.id) {
        url =  ApiUrls.GUEST_REMOVE_FROM_CART.replace('{lng}', language).replace('{cartId}', auth.cart.id);
    }
    return updateCart(language, url, message);
}

export function useAddToCart(language, message) {
    const auth = useAuth();
    let url =  ApiUrls.SHOP_ADD_TO_CART.replace('{lng}', language);
    if (!auth.isAuthenticated) {
        if (auth.cart?.id) {
            url =  ApiUrls.GUEST_ADD_TO_CART.replace('{lng}', language).replace('{cartId}', auth.cart.id);
        } else {
            url =  ApiUrls.GUEST_NEW_ADD_TO_CART.replace('{lng}', language);
        }
    }
    return updateCart(language, url, message);
}

export function useShippingMethod(language, shippingMethod) {
    const queryClient = useQueryClient();
    const shopCartQueryKey = [ApiUrls.SHOP_CART_GET.replace('{lng}', language)];
    return useMutation({
            networkMode: 'always',
            mutationFn:(shippingMethod) => axios.post(ApiUrls.CART_SET_SHIPPING_METHOD.replace('{lng}', language),
                {'shipping-method': shippingMethod})
                .then((res) => {
                    console.log(res.data);
                    if (res.data.success === true) {
                        queryClient.setQueryData(shopCartQueryKey, (prev) => {
                            return  res.data.data;
                        });
                    } else {
                        console.log(res);
                        return res.data;
                    }
                })
            ,

            onError: (error, _newFlashMessage, rollback) => {
                // console.error(error);
                // if (typeof error.response.data.error !== "undefined") {
                //     setServerErrors(error.response.data.error);
                // }

                if (rollback) rollback()
            },
            onSuccess: async (updateFlashMessage) => {
                // for (const apiLanguage of ApiLanguages) {
                //     await queryClient.invalidateQueries({queryKey: [flashMessageListQueryKey]})
                // }
            },
        }
    )
}
